import { axiosInstance } from "@helpers/axios-instance";
import { useQuery } from "@tanstack/react-query";
import { UniquePossibilities } from "../types/types";

export function useUniquePossibilities(id?: string) {
  return useQuery({
    queryKey: ["unique-possibilities", id],
    queryFn: async () => {
      const { data } = await axiosInstance({
        method: "GET",
        url:  `Household/UniquePossibilities/${id}`,
      });

      return data as UniquePossibilities;
    },
  });
}
